<div class="language-selection-item-container" [ngClass]="{'selected': selected}" (click)="languageSelected.emit(language);">
  {{language.language}}
</div>
